export default "__VITE_ASSET__D9OMeHfb__"